<template>
  <div
    class=""
    :class="showBottomBorder ? 'pb-6 mb-6 border-b border-brand-light-gray' : ''">
    <label for="edit-form-section-name">Section Name</label>
    <input v-model="sectionName" @input="emitSectionDetails" type="text" name="edit-form-section-name" id="edit-form-section-name">

    <label for="edit-form-section-directions">Section Directions</label>
    <input v-model="sectionDirections" @input="emitSectionDetails" type="text" name="edit-form-section-directions" id="edit-form-section-directions">

    <div v-if="errorMessage" class="mt-2 text-form-error">{{ errorMessage }}</div>
  </div>
</template>

<script setup>
import { ref, defineEmits } from 'vue';

const props = defineProps({
    section: Object,
    errorMessage: String,
    index: Number,
    showBorder: Boolean,
});

const sectionName = ref(props.section.name);
const sectionDirections = ref(props.section.direction);
const showBottomBorder = ref(!props.showBorder ? props.showBorder : false);

const emit = defineEmits(['editSectionDetail']);

const emitSectionDetails = () => {
  const section = {
    name: sectionName.value,
    direction: sectionDirections.value,
    index: props.index
  };
  emit('editSectionDetail', section);
};
</script>
